import styled from 'styled-components'
import { Tonality } from '@dsny/dsny-component-library'
import {
  releaseInfoDesktopContentUpQuery,
  releaseInfoTabletUpQuery
} from '../../responsiveQueries'

export const DownloadSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-top: 0;

  @media ${releaseInfoTabletUpQuery} {
    width: auto;
    flex-direction: row;
    align-items: center;
  }

  @media ${releaseInfoDesktopContentUpQuery} {
    margin-top: 6px;
  }
`

export const StyledButton = styled(Tonality.Button)`
  display: flex;
  width: 100%;
  min-height: 36px;
  padding: 6px 16px;
  border-radius: 5px;
  font-size: 14px;
  line-height: normal;

  @media ${releaseInfoTabletUpQuery} {
    width: auto;
    min-width: fit-content;
    margin-bottom: 0;
  }
`
